import { baseApi } from 'components/constants/Constants';
import { request } from '../api';

export const filterOptions = (
  text,
  type,
  segment,
  filter,
  mapper,
  success,
  handleError,
  page,
  sort
) => {
  let filters = `?type__ieq=${type}&key__icontains=${text}`;
  if (segment) {
    filters += `&segment__eq=${segment}`;
  }
  if (sort) {
    filters += `&sort=${sort}`;
  }
  if (filter) {
    filters += `&filter__icontains=${filter}`;
  }
  const options = {
    method: 'GET',
    url: `${baseApi}/reference/data${filters}&page=${page || 0}&size=100`,
    headers: { 'Content-Type': 'application/json' },
    param: {
      size: 50
    }
  };

  request(
    options,
    response => {
      const options = [];
      response.data.content.forEach(item => {
        if (mapper) {
          options.push(mapper(item));
        } else {
          options.push({
            value: item.key,
            label: item.key
          });
        }
      });
      success(options);
    },
    handleError
  );
};
